import { getPayloadFromToken } from './getCustomerIdFromToken.ts';

export const getServiceProviderIdFromToken = (token: string) => {
  const payload = getPayloadFromToken(token);

  return payload.service_provider_id;
};